import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["crmObject", "crmObjects"];
import { jsx as _jsx } from "react/jsx-runtime";
function withConvertingCrmObjectPropToArray(Component, extraProps) {
  return _ref => {
    let {
        crmObject,
        crmObjects
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const props = Object.assign({
      crmObjects: crmObject ? [crmObject] : crmObjects
    }, rest, extraProps || {});
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  };
}
export default withConvertingCrmObjectPropToArray;